import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loginUser,
  selectAuthStatus,
  selectAuthError,
  clearAuthError,
} from "../../store/authSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.scss";
import { STATUS } from "../../utils/status";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authStatus = useSelector(selectAuthStatus);
  const authError = useSelector(selectAuthError);
  const [isLoading, setIsLoading] = useState(false); // État pour gérer le chargement

  // Fonction pour afficher un message de succès à partir du backend
  const notifySuccess = (message) => {
    toast.success(message, {
      className: "toast-success",
      closeButton: false,
      autoClose: 2000,
    });
  };

  // Fonction pour afficher un message d'erreur à partir du backend
  const notifyError = (message) => {
    toast.error(message, {
      className: "toast-error",
      closeButton: false,
      autoClose: 2000,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(clearAuthError());
    setIsLoading(true); // Début du chargement

    try {
      // Tentative de connexion
      const resultAction = await dispatch(loginUser({ username, password }));

      if (loginUser.fulfilled.match(resultAction)) {
        const { otpSent, message } = resultAction.payload;

        // Affiche un message de succès à partir du backend
        notifySuccess(message);

        if (otpSent) {
          // Si l'OTP a été envoyé, redirige vers la page OTP
          setTimeout(() => {
            navigate("/otp"); // Redirige vers la page OTP
          }, 2000);
        } else {
          // Si l'OTP n'est pas nécessaire, l'utilisateur est directement connecté
          setTimeout(() => {
            navigate("/"); // Redirection vers la page d'accueil
          }, 2000);
        }
      } else {
        // Tentative échouée, affiche le message d'erreur du backend
        notifyError(resultAction.error.message);
      }
    } catch (error) {
      // Gérer les erreurs qui peuvent survenir pendant la tentative de connexion
      console.error("Login error:", error);
      notifyError("An error occurred during login.");
    } finally {
      setIsLoading(false); // Fin du chargement
    }
  };

  return (
    <div className="login">
      <div className="login-container">
        <ToastContainer hideProgressBar={false} limit={1} />
        <h1>Login</h1>
        <form onSubmit={handleLogin} className="login-fields">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button className="submit_btn" type="submit" disabled={authStatus === STATUS.LOADING}>
            {isLoading ? (
              <div className="loaderss"></div> // Ajoutez votre spinner ici
            ) : (
              "Sign in"
            )}{" "}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
